import LoginPage from "./pages/loginpage/LoginPage";
import SignPage from "./pages/signuppage/SignupPage";
import "./css/index.css";
import "./App.css";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router";
import Dashboard from "./pages/dashboard/Dashboard";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestOTP, restoreLogin } from "./features/Login/UserSlice";
import MainDashboard from "./pages/mainDashboard/MainDashboard";
import { ConfigProvider } from 'antd'; // Import ConfigProvider from antd
import OTPPage from "./pages/signuppage/OTPPage";

function App() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { login, user, authChecked } = useSelector((state) => state.user);
  const location = useLocation();

  useEffect(() => {
    dispatch(restoreLogin());

  }, [dispatch]);

  useEffect(() => {
    if (login && !user?.is_verified && user?.role === "Freemium") {
      dispatch(requestOTP({ user_id: user.id, email: user.email }))
      navigate(`/otp-verification?email=${encodeURIComponent(user.email)}&user_id=${user.id}`);
    }
  }, [user?.is_verified == false])
    

  return (
    <ConfigProvider getPopupContainer={(trigger) => trigger?.parentNode || document.body}> {}
      <div className="App">
        <Routes>
      {}
          <Route path='/*' element={login && user ? <Dashboard /> : <Navigate to="/login" replace />} />
          <Route path='/signup' element={<SignPage />} />
          <Route path='/otp-verification' element={<OTPPage />} />
          {}
          <Route path='/login' element={login && user ? <Navigate to="/dashboard" replace /> : <LoginPage />} />
          {}
          <Route path='/' element={login && user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} />
        </Routes>
      </div>
    </ConfigProvider>
  );
}

export default App;